import React, { useEffect, useRef } from "react";
import Moment from "moment";

function useListener(ref, eventName, handler) {
  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      element.addEventListener(eventName, handler)
      return () => element.removeEventListener(eventName, handler)
    }
  }, [eventName, handler, ref])
}

export default function DatePicker({
  onChange,
  onFocus,
  onBlur,
  onOpen,
  onClose,
  dateAdapter,
  localization,
  ...props
}) {
  const ref = useRef(null)

  useListener(ref, "duetChange", onChange)
  useListener(ref, "duetFocus", onFocus)
  useListener(ref, "duetBlur", onBlur)
  useListener(ref, "duetOpen", onOpen)
  useListener(ref, "duetClose", onClose)

  useEffect(() => {
    ref.current.localization = localization

    ref.current.dateAdapter = {
      parse: function parse() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ""

        if (Moment(value, localization.placeholder).format(localization.placeholder) === value){
          return Moment(value).toDate()
        }
      },
      format: function format(date) {
        return Moment(date).format(localization.placeholder)
      },
    }
  }, [localization, dateAdapter])

  return <duet-date-picker ref={ref} {...props}></duet-date-picker>
}